import styles from './InviteGroup.module.scss';

import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useInviteGroupToEventMutation } from 'legacy/events/hooks';

import { showModal } from 'legacy/actions/modalActions';

import Modal from 'legacy/common/components/modal/Modal';

import * as toast from 'legacy/common/utils/toast';
import Loader from 'legacy/common/components/layout/Loader';
import { useGetGroups } from 'legacy/groups/hooks';
import { GroupDto } from 'legacy/groups/types';

type InviteGroupProps = {
  eventId: string;
  onClose: () => void;
};

const getMessage = (group: GroupDto) => {
  if (group.metadata.memberCount === 1) {
    return 'confirmInviteGroupOneGuest';
  }

  if (group.metadata.memberCount === 2) {
    return 'confirmInviteGroupTwoGuests';
  }

  return 'confirmInviteGroupMultipleGuests';
};

const InviteGroup: React.FC<InviteGroupProps> = ({ eventId, onClose }) => {
  const { t } = useTranslation(['events', 'organizations']);
  const dispatch = useDispatch();
  const { mutate: invite, isLoading } = useInviteGroupToEventMutation();

  const { data, isLoading: isLoadingGroups } = useGetGroups({
    role: ['owner', 'admin', 'member']
  });
  const groups = data?.items;

  const inviteMembers = (group: GroupDto) => {
    dispatch(
      showModal('CONFIRMATION', {
        type: 'success',
        message: t(`events:invite.${getMessage(group)}`, {
          title: group.name,
          count: group.metadata.memberCount
        }),
        onSuccess: ({ close }) => {
          close();

          invite(
            {
              groupId: group.id,
              eventId
            },
            {
              onSuccess: () => {
                onClose();
                toast.success(
                  t('events:invite.successFromGroup', {
                    title: group.name
                  })
                );
              },
              onError: (error) => {
                toast.error(error.message);
              }
            }
          );
        }
      })
    );
  };

  return (
    <Modal visible onClose={onClose}>
      <Loader isLoading={isLoading}>
        <div className={styles.wrapper}>
          <div className={styles.title}>{t('events:invite.inviteGroup')}</div>
          <Loader isOverlay isLoading={isLoadingGroups}>
            {groups?.length === 0 && (
              <div className={styles.empty}>{t('events:invite.noGroups')}</div>
            )}

            <div className={styles.listWrapper}>
              {groups?.map((group) => (
                <div
                  key={group.id}
                  className={styles.group}
                  onClick={() => {
                    inviteMembers(group);
                  }}
                >
                  <img className={styles.cover} src={group?.coverImageUrl} />
                  <img className={styles.badge} src={group?.badgeImageUrl} />
                  <div className={styles.spacer} />
                  <div className={styles.groupName}>{group?.name}</div>
                  <div className={styles.members}>
                    {t('organizations:members.membersCount', {
                      count: group?.metadata.memberCount
                    })}
                  </div>
                </div>
              ))}
            </div>
          </Loader>
        </div>
      </Loader>
    </Modal>
  );
};

export default InviteGroup;
